/**
 * Immutable constant map for software installation status values.
 *
 * Use these constants instead of inline string literals to ensure
 * consistent comparisons across the UI.
 */
export const SoftwareInstallationStatusConstants = {
  /** Software was installed successfully. */
  INSTALLED: 'installed',
  /** Software installation failed; an error message is available. */
  FAILED: 'failed',
  /** Synthetic status — item is in the stack but has no status entry yet. */
  PENDING: 'pending',
} as const;

/** Union type of all valid installation status values. */
export type SoftwareInstallationStatusValue =
  typeof SoftwareInstallationStatusConstants[keyof typeof SoftwareInstallationStatusConstants];
